import { Badge, Button, Card, Image, Typography } from "antd";
import { useState, useEffect } from "react";
import { ReactComponent as DurationIcon } from "../../assets/images/reusable-items/duration.svg";
import testImage from "../../assets/images/default-cover-image.jpg";
import { ReactComponent as LessonIcon } from "../../assets/images/reusable-items/lesson.svg";
import { ReactComponent as CourseIcon } from "../../assets/images/reusable-items/course.svg";
import { ReactComponent as ModuleIcon } from "../../assets/images/reusable-items/module.svg";
import { ReactComponent as QuizzieIcon } from "../../assets/images/reusable-items/quizzie.svg";
import MenuItems from "../../assets/images/menu-items";

import {
  CheckCircleOutlined,
  LockOutlined,
  UnlockOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const { Text } = Typography;
const cloudfrontKey = process.env.REACT_APP_CLOUDFRONT_KEY;

const OnboardingCard = (props: any) => {
  const {
    title,
    coverImageKey,
    path,
    entity,
    orderIndex,
    isFinished,
    inProgress,
    locked,
  } = props;
  const [imageSrc, setImageSrc] = useState("");

  const navigate = useNavigate();

  useEffect(() => {
    setImageSrc(`${cloudfrontKey}/${coverImageKey}`);
    if (coverImageKey === "" || !coverImageKey) setImageSrc(testImage);
  }, [coverImageKey]);

  return (
    <Card
      className={`shadow-md p-3 pb-0 w-[350px] ${
        locked ? "is-locked pointer-events-none" : ""
      }`}
    >
      <div className="flex w-full h-full gap-8 mb-3">
        <div className="flex-1">
          <Badge.Ribbon text={orderIndex} placement="start">
            <Image
              src={imageSrc}
              preview={false}
              height={110}
              className="rounded-lg object-contain w-[179px]"
            />
          </Badge.Ribbon>
        </div>

        <div className="flex-1 flex flex-col justify-between gap-3">
          <div className="flex gap-2 justify-between">
            <Text className="text-sm text-neutral-600 font-semibold line-clamp-3">
              {title}
            </Text>
            {entity === "View Course" ? (
              <CourseIcon className="min-w-6 h-6 fill-primary-500" />
            ) : entity === "View Module" ? (
              <ModuleIcon className="min-w-6 h-6 fill-primary-500" />
            ) : entity === "View Lesson" ? (
              <LessonIcon className="min-w-6 h-6 fill-primary-500" />
            ) : entity === "View Quizzie" ? (
              <QuizzieIcon className="min-w-6 h-6 fill-primary-500" />
            ) : entity === "View Task" ? (
              <MenuItems.Task className="text-2xl h-6 text-primary-600" />
            ) : null}
          </div>
          <div>
            <div>
              <Button
                className="w-full  text-primary-600 border-primary-200 text-xs p-2 h-6 font-semibold"
                onClick={() => navigate(path)}
              >
                {entity}
              </Button>
            </div>
          </div>
        </div>
      </div>
      {isFinished ? (
        inProgress == undefined ? (
          <div className="text-center py-1 px-0 text-xs text-white bg-success-600 mx-[-12px] rounded-t-none rounded-b">
            Completed
            <CheckCircleOutlined
              style={{
                marginLeft: 8,
              }}
            />
          </div>
        ) : inProgress ? (
          <div className="text-center py-1 px-0 text-xs text-white bg-success-600 mx-[-12px] rounded-t-none rounded-b">
            In Progress
          </div>
        ) : (
          <div className="text-center py-1 px-0 text-xs text-white bg-success-600 mx-[-12px] rounded-t-none rounded-b">
            Completed
            <CheckCircleOutlined
              style={{
                marginLeft: 8,
              }}
            />
          </div>
        )
      ) : !isFinished && !locked ? (
        <div className="text-center py-1 text-xs px-0 text-white bg-primary-500 mx-[-12px] rounded-t-none rounded-b">
          Unlocked
          <UnlockOutlined
            style={{
              marginLeft: 8,
            }}
          />
        </div>
      ) : (
        <div className="text-center py-1 px-0 text-xs text-white bg-primary-900 mx-[-12px] rounded-t-none rounded-b">
          Locked
          <LockOutlined
            style={{
              marginLeft: 8,
            }}
          />
        </div>
      )}
    </Card>
  );
};

export default OnboardingCard;
